import { media } from "src/styles/mixins";
import styled from "styled-components";

export const AgreementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 8px;
`;

export const AgreementProgressWrapper = styled.div`
  width: 128px;
  height: 64px;
  overflow: hidden;

  .CircularProgressbar-trail {
    stroke: ${({ theme }) => theme.colors.agreement.progressBg};
    stroke-width: 4;
  }

  .CircularProgressbar-path {
    stroke: ${({ theme }) => theme.colors.agreement.progressFill};
    transition: stroke-dashoffset 1s ease;
  }

  ${media.down("LAPTOP")`
    width: 96px;
    height: 48px;
  `}
`;

export const BirdWrapper = styled.div`
  & > div {
    display: flex;
    transform: translateY(-50%);
    overflow: hidden;
  }

  svg {
    width: 65px;
    height: 65px;
    transform: translateY(10%);
  }

  ${media.down("LAPTOP")`
    svg {
      width: 48px;
      height: 48px;
    }
  `}
`;

export const AgreementUnderline = styled.div`
  width: 160px;
  height: 2px;
  background-color: ${({ theme }) => theme.colors.agreement.progressBg};

  ${media.down("LAPTOP")} {
    width: 128px;
  }
`;
